<template>
  <temp
    ref="temp"
    type="school"
    :data="sourceData"
    :zhilian="$env.link.agency.zhilian"
    :job51="$env.link.agency.job51"
  ></temp>
</template>

<script>
import axios from 'axios'
import temp from '@/components/temp'
export default {
  data () {
    return {
      sourceData: []
    }
  },
  created () {
    // 3 校招
    axios.get('/jobser/category/jobs', {
      params: {
        module_id: this.$env.module.school
      }
    }).then(res => {
      this.sourceData = res.data.data
      this.$refs.temp.init()
    })
  },
  components: {
    temp
  }
}
</script>
